export default __webpack_public_path__ + "static/media/logo_bianco.5b1dde57.png";